<div class="alert fade show" [class]="classes"   ng role="alert">
  <i *ngIf="dismissible" class="alert-close" data-dismiss="alert" (click)="closeAlert()" aria-hidden="true" aria-label="Close"></i>
  <span class="alert-message"><ng-content></ng-content></span>
</div>
